/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import { FiraSansBold } from 'components/Text';
import { mediaHelperMaxWidth } from "../../utils/src";
import Colors from 'constants/Colors';
import { Breakpoints } from "../../constants/Breakpoints";

export const FieldWrapper = styled.div`
  padding: 10px 0;
  position: relative;
  display: ${({ flex }) => flex ? `flex` : 'block'};
  width: ${({ desktopWidth }) => desktopWidth ? `${desktopWidth}%` : '33%'};
  min-width: ${({ desktopWidth }) => desktopWidth ? `${desktopWidth}%` : '33%'};
  margin-top: ${({ marginTop }) => marginTop === 0 ? '0' : (marginTop ? `${marginTop}px` : 'auto')};
  margin-right: ${({ marginRight }) => marginRight ? `${marginRight}px` : '0'};
  padding-right: ${({ paddingRight }) => paddingRight !== null && paddingRight !== undefined ? `${paddingRight}px` : '20px'};

  ${mediaHelperMaxWidth.md`
    width: ${({ tabletWidth }) => tabletWidth ? `${tabletWidth}%` : '50%'};
    min-width: ${({ tabletWidth }) => tabletWidth ? `${tabletWidth}%` : '50%'};
  `}

  ${mediaHelperMaxWidth.sm`
    width: ${({ mobileWidth }) => mobileWidth ? `${mobileWidth}%` : '100%'};
    min-width: ${({ mobileWidth }) => mobileWidth ? `${mobileWidth}%` : '100%'};
  `}
`;

export const Container = styled.div`
  display:flex;
  flex-flow: row;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-center;
  padding-bottom: 0;
`;

export const CalendarContainer = styled.div`
  z-index: 999999;
  top: 60px;
  ${({ isFlex }) => isFlex ? `right: 1px;` : `left: 1px;`};
  position: absolute;
`;

export const BorderSwitch = styled.div`
  ${({ error }) => error ? `background: ${Colors.DANGER}` : `background: ${Colors.GRAY[6]}`};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  padding-right: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 5px;
  margin-bottom: 36px
`;

export const AddButton = styled.button`
  display: flex;
  width:50px;
  border: 0px;
  margin: 0 5px;
  background-color:transparent;
  cursor: pointer;
  align-self: center;
`;

export const BottomSeparatorLine = styled.div`
  width: 100%;
  border-bottom: solid 1px ${Colors.GRAY[3]};
`;